import styled, { css } from 'styled-components';
import { TamanhosCartaz } from '.';

export const Container = styled.div<{
  $tamanho: TamanhosCartaz;
  $temImagem: boolean;
}>`
  position: relative;
  border-radius: ${({ theme }) => theme.radius[2]}px;
  overflow: hidden;
  background-color: ${({ theme, $temImagem }) =>
    $temImagem ? '' : theme.colors.neutral.neutral[5]};

  ${({ $tamanho, theme }) => {
    return css`
      height: ${theme.tamanhoCartaz.height[$tamanho]}px;
      width: ${theme.tamanhoCartaz.width[$tamanho]}px;
    `;
  }}
`;
